
    <app-circle-btn delete (btnClicked)="btnEvent()">
      <app-delete-icon></app-delete-icon>
    </app-circle-btn>
  